import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=3fac12ff&scoped=true&lang=html&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fac12ff",
  null
  
)

export default component.exports